import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Permission, userNamespace } from "@/store/modules/user";
import { User } from "@/store/modules/user/types";
import { Alert } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import AlertMessage from "./AlertMessage";
import VerifyForm from "./VerifyForm";

@Component({
  components: { AlertMessage, VerifyForm }
})
export default class Alerts extends Vue {
  @Prop(Array)
  alerts!: Array<Alert>;

  @Prop(Boolean)
  hideAlerts!: boolean;

  @Prop(Boolean)
  showTime!: boolean;

  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  @Getter("demo", userNamespace)
  demo!: boolean;

  @Getter("user", userNamespace)
  user!: User;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("isMobile", navigationNamespace)
  isMobile!: boolean;

  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("verifyMode", patientNamespace)
  verify!: boolean;

  @Getter("currentRoomName", patientNamespace)
  currentRoomName!: string;

  @Getter("selectedView", patientNamespace)
  selectedView!: string;

  @Prop(Boolean)
  hideDivider!: boolean;

  get showChangeRoomButton() {
    if (
      this.user.route === null ||
      this.user.route === undefined ||
      this.selectedView == "multipatient"
    ) {
      return false;
    } else {
      return !this.$route.path.startsWith(
        this.user.route
          .split("?")[0]
          .replace("/#", "")
          .replace("#", "")
      );
    }
  }

  get actualRoomName() {
    return this.user.room;
  }

  get filteredAlerts() {
    return this.alerts
      .filter(alert => {
        return alert.level > 0;
      })
      .sort((a, b) => {
        const level = b.level - a.level;
        if (level == 0) {
          return a.id.localeCompare(b.id);
        }
        return level;
      });
  }

  get showPagingIcon() {
    return (
      !this.user.rights.includes(Permission.NO_EDIT) &&
      this.config.global.showPagingIcon
    );
  }

  get pagingIcon() {
    const icons = this.alerts
      .map(alert => alert.icon)
      .filter(icon => {
        return icon.indexOf("alertSettings") !== -1;
      });
    if (icons.length) {
      const icon = icons[0];
      return `${icon}`;
    } else {
      return "alertSettings1.png";
    }
  }

  get warningLabelStatus() {
    return (
      this.vars.system &&
      this.vars.system.warningLabel &&
      this.vars.system.warningLabel ===
        "Check monitors and medical record before making medical decisions."
    );
  }

  get warningLabel() {
    return this.vars.system && this.vars.system.warningLabel
      ? this.vars.system.warningLabel
      : "Missing warning label. Do not use for clinical decisions.";
  }

  goBackToRoom() {
    const route = this.user.route;
    if (route !== "" && route.replace("/#", "") !== this.$route.path) {
      this.$router.push(route.replace("/#", "").replace("#", ""));
    }
  }
}
